<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">扣款列表({{elderlyName}})</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">


        <el-table :data="tableData" ref="tableElderlyRel" style="width: 100%" border :height="300">

          <el-table-column prop="elderlyName" label="老人"></el-table-column>
          <el-table-column prop="lessBalance" label="扣款"></el-table-column>
          <el-table-column prop="afterBalance" label="扣款后"></el-table-column>
          <el-table-column prop="beforeBalance" label="扣款前"></el-table-column>
          <el-table-column prop="dayString" label="时间"></el-table-column>

        </el-table>

        <div class="page">
          <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="pageSize"
                :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: 'ElderlyRel',
  props:[],
  data() {
    return {

      loading: false,
      tableData:[],
      totalItems:0,
      pageSize: 20,
      currentPage: 1,

      elderlyCode:'',
      elderlyName:'',

    }
  },
  components:{

  },
  methods: {

    init(elderlyCode,elderlyName){
      this.elderlyCode = elderlyCode;
      this.elderlyName = elderlyName;
      this.getElderlyList()
    },
    closeSelf() {
      this.$emit("closeElderly");
    },

    timefilter(row,index,column){
      return timefilters(column)
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getElderlyList();
    },

    getElderlyList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"LessDay/PageElderly",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          elderlyCode:this.elderlyCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.tableData=response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;

          this.$nextTick(()=>{
            this.$refs.tableElderlyRel.doLayout();
          });

        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      })
    },


  }
}


</script>


